import { render, staticRenderFns } from "./SignatureResume.vue?vue&type=template&id=48ed1074"
import script from "./SignatureResume.vue?vue&type=script&lang=js"
export * from "./SignatureResume.vue?vue&type=script&lang=js"
import style0 from "./SignatureResume.vue?vue&type=style&index=0&id=48ed1074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports